export default function PrimaryButton({ children, disabled, ...props }) {
  return (
    <button
      disabled={disabled}
      className={
        "w-full rounded-2xl py-4 font-semibold tracking-wide transition " +
        (disabled
          ? "bg-gray-200 text-gray-500 cursor-not-allowed"
          : "bg-gradient-to-r from-orange-500 to-orange-600 hover:brightness-110 active:brightness-95")
      }
      {...props}
    >
      {children}
    </button>
  );
}
